import { bind } from 'decko'
import Cookies from 'js-cookie'
import { LiveElement } from 'live-node-list'

export default class NewsletterPopup {
  /**
   * @type {LiveElement}
   */
  newsletterPopup = new LiveElement('.newsletter-popup')

  /**
   * @type {LiveElement}
   */
  newsletterPopupCloseButton = new LiveElement(
    '.newsletter-popup__close-button'
  )

  constructor() {
    this.registerListeners()
  }

  @bind
  registerListeners() {
    if (!this.newsletterPopup.item) {
      return
    }

    if (!Cookies.get('newsletter_popup')) {
      setTimeout(() => {
        this.openNewsletterPopup()
      }, 10000)
    }

    this.newsletterPopupCloseButton.addEventListener(
      'click',
      this.closeNewsletterPopup
    )
  }

  @bind
  openNewsletterPopup() {
    this.newsletterPopup.item.classList.add('newsletter-popup--active')
    document.body.classList.add('lock-scroll')
  }

  @bind
  closeNewsletterPopup() {
    this.newsletterPopupCloseButton.item.blur()
    this.newsletterPopup.item.classList.remove('newsletter-popup--active')
    document.body.classList.remove('lock-scroll')
    Cookies.set('newsletter_popup', true, { expires: 7 })
  }
}
